import _regenerator from "/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { GET_SPEACH_FROM_SPEACH_ID, REFRESH_COUR_IN_SPEACH_TO_COPY } from '@/store/actions/speach';
import SpeachConfigureTable from '@/components/platform/copySpeach/SpeachConfigureTable.vue';
var ConfigureSpeach = /*#__PURE__*/function (_Vue) {
  function ConfigureSpeach() {
    _classCallCheck(this, ConfigureSpeach);
    return _callSuper(this, ConfigureSpeach, arguments);
  }
  _inherits(ConfigureSpeach, _Vue);
  return _createClass(ConfigureSpeach, [{
    key: "listSpeach",
    get:
    // -- Computed variables
    function get() {
      return store.getters.listSpeachToCopy;
    }
  }, {
    key: "destinationPlatform",
    get: function get() {
      return store.getters.destinationPlatform;
    }
  }, {
    key: "sourcePlatform",
    get: function get() {
      return store.getters.sourcePlatform;
    }
    // -- CUSTOM FUNCTIONS
  }, {
    key: "refreshCourAndAddToList",
    value: function () {
      var _refreshCourAndAddToList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              store.dispatch(GET_SPEACH_FROM_SPEACH_ID, {
                platformID: this.sourcePlatform.platformID,
                speachID: row.speachID
              }).then(function (cour) {
                if (cour) {
                  store.dispatch(REFRESH_COUR_IN_SPEACH_TO_COPY, cour);
                }
              });
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function refreshCourAndAddToList(_x) {
        return _refreshCourAndAddToList.apply(this, arguments);
      }
      return refreshCourAndAddToList;
    }()
  }]);
}(Vue);
ConfigureSpeach = __decorate([Options({
  components: {
    SpeachConfigureTable: SpeachConfigureTable
  }
})], ConfigureSpeach);
export default ConfigureSpeach;